let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("576vh")).then(() => parcelRequire('9rc9C'));